import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const MonetizationContext = createContext();

export const MonetizationProvider = ({ children }) => {
  const [monetizations, setMonetizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMonetizations = async () => {
      try {
        const SERVER_URL = process.env.REACT_APP_SERVER_URL;
        const response = await axios.get(`${SERVER_URL}/api/monetizations/`);
        setMonetizations(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchMonetizations();
  }, []);

  return (
    <MonetizationContext.Provider value={{ monetizations, loading, error }}>
      {children}
    </MonetizationContext.Provider>
  );
};
